module.exports = __webpack_public_path__ + "img/00625064000188.07da44e9.png";